import { IconEdit, IconX } from '@tabler/icons-react'
import React, { useState } from 'react'
import { Modal } from 'react-bootstrap';
import { loadingHide, loadingShow } from '../../../loadingUi/loading.controller';
import { uploadImage } from '../../../api/api.global';
import { postApi } from '../../../api/call.api';
import { urlApi } from '../../../api/url.api';
import { toast } from 'sonner';

const UpdateUserDetails = ({ userData, callback, buttonComponent }) => {
    const [show, setShow] = useState(false);
    const [file, setFile] = useState(null);

    const handleClose = () => { setFile(null); setShow(false) };
    const handleShow = () => setShow(true);

    function fileOnChange(event) {
        setFile(event.target.files[0]);
        let file = event.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            document.getElementById('pic-preview').src = reader.result;
        }
    }

    async function update() {
        loadingShow();
        let postData = {
            "userId": userData?._id,
            "name": document.getElementById('user-name')?.value,
            "profilePic": file ? await uploadImage(file, "advy-user-profile-pic") : document.getElementById('pic-preview')?.src
        }
        if (document.getElementById('website')?.value?.trim()) {
            postData["website"] = document.getElementById('website')?.value?.trim();
        }
        if (document.getElementById('company-name')?.value?.trim()) {
            postData["company"] = document.getElementById('company-name')?.value?.trim();
        }
        let resp = await postApi(postData, urlApi.updateUserDetails);
        loadingHide();
        if (resp.responseCode === 200) {
            toast.success(resp.message);
            if (callback) {
                callback();
            }
            handleClose();
        } else {
            toast.error(resp.message);
        }
    }

    return (
        <>
            <div onClick={handleShow} className='w-max'>{buttonComponent}</div>

            <Modal show={show} onHide={handleClose} backdrop="static" >
                <Modal.Body className='rounded-xl'>
                    <div className="flex justify-between items-center">
                        <p className="text-md font-semibold">Update User</p>
                        <IconX className='cursor-pointer' onClick={handleClose} />
                    </div>
                    <hr className='my-3' />
                    <div className='flex flex-col gap-2'>
                        <div className="flex flex-col gap-1">
                            <label htmlFor="user-name" className='font-medium'>Name</label>
                            <input type="text" id='user-name' placeholder="Name" className='p-2 text-sm rounded-xl bg-transparent border-2 border-[var(--light-text)]' defaultValue={userData?.name} />
                        </div>
                        <div className="flex flex-col gap-1">
                            <label className='text-gray-600'>Mobile</label>
                            <input type="text" readOnly placeholder="Mobile" className='p-2 text-sm cursor-not-allowed text-gray-700 rounded-xl bg-transparent border-2 border-[var(--light-text)]' defaultValue={userData?.phone} />
                        </div>
                        <div className="flex flex-col gap-1">
                            <label className='text-gray-600'>Email</label>
                            <input type="text" readOnly placeholder="Email" className='p-2 text-sm cursor-not-allowed text-gray-700 rounded-xl bg-transparent border-2 border-[var(--light-text)]' defaultValue={userData?.email} />
                        </div>
                        <div className="flex flex-col gap-1">
                            <label htmlFor="company-name" className='font-medium'>Company Name</label>
                            <input type="text" id='company-name' placeholder="Company Name" className='p-2 text-sm rounded-xl bg-transparent border-2 border-[var(--light-text)]' defaultValue={userData?.company} />
                        </div>
                        <div className="flex flex-col gap-1">
                            <label htmlFor="website" className='font-medium'>Website</label>
                            <input type="text" id='website' placeholder="Website URL" className='p-2 text-sm rounded-xl bg-transparent border-2 border-[var(--light-text)]' defaultValue={userData?.website} />
                        </div>
                        <label htmlFor="category-file" className='font-medium'>Profile Pic</label>
                        <input type="file" name="" id="category-file" onChange={(e) => fileOnChange(e)} className='w-full p-2 text-sm rounded-xl bg-transparent border-2 border-[var(--light-text)]' accept="image/png, image/gif, image/jpeg" />
                        <img src={userData?.profilePic} alt="" id='pic-preview' className='max-h-[200px] min-h-[100px] mt-2 max-w-full object-contain rounded-md' />
                    </div>
                    <hr className='my-3' />
                    <div className='flex justify-end gap-3'>
                        <button className='px-4 py-1 bg-[var(--secondary)] text-white text-sm font-semibold rounded-lg' onClick={handleClose}>Cancel</button>
                        <button className='px-4 py-1 bg-[var(--secondary-gradient-1)] text-white text-sm font-semibold rounded-lg' onClick={() => update()}>Update</button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default UpdateUserDetails